import * as Redux from 'redux'
import { connect } from 'react-redux'
import { IFirearms } from '@Models/client/firearm.model'
import React, { useState } from 'react'
import ClientFirearmActions from '@ClientActions/firearm.action'
import Product from '@Components/Product/Product'
import { Grid } from '@mui/material'
import { ICommonProduct, MCommonProduct } from '../../../models/common.model'
import BuyerInfoModal from './BuyerInfoModal'

interface IFirearmProps {
    data: any
    submitDisposeItem: (id: string, params: any) => Promise<any>
    submitChanged: () => void
}
function Firearms(props: IFirearmProps) {
    const { data, submitDisposeItem, submitChanged } = props
    const [showModal, setShowModal] = useState(false)
    const [itemId, setItemId] = useState('')
    const onHandleAction = (value: string, item: any) => {
        setShowModal(true)
        setItemId(item?.id)
    }
    const newData = data?.map((item: any) => new MCommonProduct({ ...item }))

    const onSubmitForm = (body: any) => {
        submitDisposeItem(itemId, body).then(() => {
            submitChanged()
            setShowModal(false)
        })
    }
    return (
        <>
            {newData?.map((item: IFirearms) => (
                <React.Fragment key={`${item?.id}_gun_list_item`}>
                    <Grid item md={6} sm={12}>
                        <Product
                            checkbox={false}
                            action
                            product={item}
                            getActions={onHandleAction}
                            productType={
                                item?.type === 'PART' ? 'PART' : undefined
                            }
                        />
                    </Grid>
                </React.Fragment>
            ))}
            <BuyerInfoModal
                open={showModal}
                onClose={() => setShowModal(false)}
                onSubmitForm={(body: any) => onSubmitForm(body)}
            />
        </>
    )
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        submitDisposeItem: (id: string, payload: any) =>
            dispatch(
                ClientFirearmActions.createDisposeItem(id, payload) as any
            ),
    }
}
export default connect(null, mapDispatchToProps)(Firearms)
